import routerOptions0 from "/home/runner/_work/shadow/shadow/node_modules/.pnpm/nuxt@3.21.1_@parcel+watcher@2.5.1_@types+node@24.10.8_@vue+compiler-sfc@3.5.30_cac@6.7._8c6dcd9cd951d388c89912f1103db9be/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}